<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-5">
        <label for="ddlDaySchedule">Day Schedule</label>
        <select class="form-control" id="ddlDaySchedule" v-model="scopedSelectedDayScheduleId"
                @change="change_selected_day_schedule_id()">
          <option value="0">Select..</option>
          <option v-for="day_schedule in filtered_day_schedules" :key="day_schedule.day_schedule_id" v-bind:value="day_schedule.day_schedule_id" >
            {{ day_schedule.name }} ({{ day_schedule.day_schedule_id }})
          </option>
        </select>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-5">
        <div class="dropdown">
          <button class="btn btn-light dropdown-toggle" type="button" id="ddlDayScheduleManage"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-cog fa-fw" aria-hidden="true"></i> Manage
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <router-link :to="{ name: 'AddDaySchedule' }" class="dropdown-item"><i class="fa fa-edit"
                                                                                   aria-hidden="true"></i> Add
            </router-link>
            <a class="dropdown-item" @click="createExportFile()"><i class="fa fa-file"></i> Export All</a>
            <div class="dropdown-divider" v-show="selected_day_schedule_id !== 0"></div>
            <router-link :to="{ name: 'EditDaySchedule', params: { day_schedule_id: selected_day_schedule_id } }"
                         v-show="selected_day_schedule_id !== 0"
                         class="dropdown-item"><i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i> Edit
            </router-link>
            <router-link :to="{ name: 'CopyDaySchedule', params: { day_schedule_id_to_copy: selected_day_schedule_id} }"
                         v-show="selected_day_schedule_id !== 0" class="dropdown-item">
              <i class="far fa-clone" aria-hidden="true"></i> Copy
            </router-link>
            <button class="dropdown-item" @click="clearDaySchedule(selected_day_schedule_id)" v-show="selected_day_schedule_id !== 0">
              <i class="fa fa-recycle fa-fw" aria-hidden="true"></i> Clear Bells
            </button>
            <a class="dropdown-item" href="#" onclick="return false"
               v-show="selected_day_schedule_id !== 0"
               @click="deleteDaySchedule(selected_day_schedule_id)"><i
              class="fa fa-trash fa-fw"
              aria-hidden="true"></i>&nbsp;Delete</a>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-12">
        <DayScheduleItemsTable :selected_day_schedule_id="Number(scopedSelectedDayScheduleId)"></DayScheduleItemsTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DayScheduleItemsTable from '../../../components/Scheduler/Day/DayScheduleItemsTable'

export default {
  components: { DayScheduleItemsTable },
  data: function () {
    return {
      scopedSelectedDayScheduleId: 0
    }
  },
  computed: {
    ...mapGetters({
      selected_day_schedule_id: 'selectedDayScheduleId',
      day_schedules: 'allDaySchedules',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_day_schedules: function () {
      return this.day_schedules.filter(daySchedule => daySchedule.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.scopedSelectedDayScheduleId = this.selected_day_schedule_id
    this.$store.dispatch('getDaySchedules')
    this.$store.dispatch('getSounds')
  },
  methods: {
    ...mapActions([
      'clearDaySchedule'
    ]),
    createExportFile () {
      let fileExport = {
        type: 'schedule'
      }

      this.$store.dispatch('createExportFile', fileExport)
    },
    change_selected_day_schedule_id () {
      this.$store.dispatch('changeSelectedDayScheduleId', this.scopedSelectedDayScheduleId)
    },
    deleteDaySchedule () {
      this.$store.dispatch('deleteDaySchedule', this.selected_day_schedule_id)
      this.scopedSelectedDayScheduleId = 0
    }
  }
}
</script>

<style scoped>
</style>
